import React, {useEffect} from "react";
import RadioFields from "../fields/RadioFields";
import {Field} from "react-final-form";
import SelectField from "../fields/SelectField";
import {useSelector} from "react-redux";
import {composeValidators, required, limit} from "../../helpers/ValidateHelper";
import OtherField from "../fields/OtherField";
import useIsMobile from "../../helpers/MobileHelper";
import WindowWidthProvider from "../../helpers/WindowWidthProvider";
import {useForm, useFormState} from "react-final-form";
import {useIsShowMap} from "../../hooks/useIsShowMap";
import QueryStorage from "../../../../../common/helpers/QueryStorage";

function PaperFormat({menuPlacement}) {
    const {paperFormat} = useSelector(state => state.orderOptions.data);

    const isMobile = useIsMobile();
    const windowWidth = WindowWidthProvider();
    const {change} = useForm();
    const {values} = useFormState();
    const {paperFormat: isShow} = useIsShowMap(values);

    useEffect(() => {
        const savedPaperFormat = QueryStorage.get("paperFormat");
        const savedPaperFormatOther = QueryStorage.get("paperFormatOther");
        if (savedPaperFormat) {
            change("paperFormat", savedPaperFormat);
        }
        if (savedPaperFormatOther) {
            change("paperFormatOther", savedPaperFormatOther);
        }
    }, [change]);

    useEffect(() => {
        if (values.paperFormat) {
            QueryStorage.set("paperFormat", values.paperFormat);
        }
        if (values.paperFormatOther && values.paperFormat === 'Other') {
            QueryStorage.set("paperFormatOther", values.paperFormatOther);
        } else {
            QueryStorage.remove("paperFormatOther");
        }
    }, [values.paperFormat, values.paperFormatOther]);

    if (!isShow) {
        return null;
    }

    return <div className={`form-group ${menuPlacement ? "fg-paper-format" : ""}`}>
        <div className="form-label">Paper format</div>
        {!isMobile ?
            <RadioFields
                name="paperFormat"
                options={paperFormat}
            /> : <Field
                name="paperFormat"
                component={SelectField}
                isSearchable={false}
                currentWidth={windowWidth}
                options={paperFormat}
                menuPlacement={menuPlacement}
            />}
        <OtherField
            name="paperFormatOther"
            watch="paperFormat"
            validate={composeValidators(
                required('Please specify type paper format'),
                limit('Maximum {limit} characters allowed. You\'ve used {count}.', 255)
            )}
        />
    </div>
}

export default PaperFormat;
